import { Col } from 'antd';
import { Auth, FieldRow, Form } from '@/components';
import { GenerateTasksReportArgs } from '@/redux';
import { useClientLookupSource } from '../Clients.Common';
import { useFormikContext } from 'formik';
import { useReportingCommunitiesLookupSource } from '../Communities.Common';
import { useReportingProjectsLookupSource } from '../Projects.Common';
import { useReportingHomesLookupSource } from '../Homes.Common';
import { useEffect } from 'react';
import { useAssignedResponsiblePersonsLookupSource } from '../Tasks.Common';
import { TaskStatus } from '@/core';

export function FormGenerateTasksReport() {
  const { values, setFieldValue } = useFormikContext<GenerateTasksReportArgs>();
  const { clientIds, communityIds, projectIds, homeIds } = values;

  const clientDataSource = useClientLookupSource();
  const communityDataSource = useReportingCommunitiesLookupSource(clientIds);
  const projectDataSource = useReportingProjectsLookupSource(
    false,
    communityIds,
  );
  const homeDataSource = useReportingHomesLookupSource(
    clientIds ?? undefined,
    communityIds ?? undefined,
    projectIds,
  );
  const responsiblePersonDataSource = useAssignedResponsiblePersonsLookupSource(
    communityIds,
    projectIds,
    homeIds,
  );

  useEffect(() => {
    setFieldValue(`communityIds`, []);
  }, [clientIds, setFieldValue]);

  useEffect(() => {
    setFieldValue(`projectIds`, []);
  }, [communityIds, setFieldValue]);

  useEffect(() => {
    setFieldValue(`homeIds`, []);
  }, [projectIds, setFieldValue]);

  useEffect(() => {
    setFieldValue(`responsiblePersonValues`, []);
  }, [projectIds, clientIds, communityIds, setFieldValue]);

  return (
    <>
      <FieldRow>
        <Col span={12}>
          <Form.Date name="startDate" allowClear={false} />
        </Col>
        <Col span={12}>
          <Form.Date name="endDate" allowClear={false} />
        </Col>
      </FieldRow>
      <FieldRow>
        <Auth role="BFP_ADMIN">
          <Col span={12}>
            <Form.AsyncSelect
              dataSource={clientDataSource}
              name="clientIds"
              mode="multiple"
              required
            />
          </Col>
        </Auth>
        <Col span={12}>
          <Form.AsyncSelect
            key={clientIds.join()}
            dataSource={communityDataSource}
            name="communityIds"
            mode="multiple"
            required
          />
        </Col>
      </FieldRow>
      <FieldRow>
        <Col span={12}>
          <Form.AsyncSelect
            key={communityIds.join()}
            dataSource={projectDataSource}
            name="projectIds"
            mode="multiple"
          />
        </Col>
        <Col span={12}>
          <Form.AsyncSelect
            key={projectIds?.join()}
            dataSource={homeDataSource}
            name="homeIds"
            mode="multiple"
          />
        </Col>
      </FieldRow>
      <FieldRow>
        <Col span={12}>
          <Form.AsyncSelect
            key={communityIds.join()}
            dataSource={responsiblePersonDataSource}
            name="responsiblePersonValues"
            mode="multiple"
          />
        </Col>
        <Col span={12}>
          <Form.EnumSelect type={TaskStatus} name="statuses" mode="multiple" />
        </Col>
      </FieldRow>
    </>
  );
}
